import { Component, OnInit } from '@angular/core';
import { OdmoriService } from '../odmori.service';
import { ToastrService } from 'ngx-toastr';
import { Globals } from "@app/services/globals.service";
import { PermissionsService } from '@app/components/permissions/permissions.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileDownloadService } from "@app/services/file-download.service";
import { ConstantsService } from '@app/services/constants/constants.service';

@Component({
  selector: 'podesavanja',
  templateUrl: './podesavanja.component.html',
  styleUrls: ['./podesavanja.component.css']
})

export class PodesavanjaComponent implements OnInit {
  users: any;
  selectedYear: any;
  selectedYearPreview: any;
  showEmployeeAbsenceData: boolean = false;
  employeesAbsenceData: any;
  pending: boolean = false;
  previewEmployees: boolean = false;
  pendingSave: boolean = false;
  showDays: boolean =  false;
  preview: boolean = false;
  showPermissions: boolean = false;
  showPermittedUsers: boolean = false;

  form: FormGroup;
  assigned = new FormControl([], Validators.required);
  isLoading: boolean = false;

  allAbsences: boolean;
  years: number[] = [];
  yearControl = new FormControl([]);
  selectedYears: number[] = [];

  pendingExport: boolean = false;

  allowedUserPermission: any;

  pendingSaveUser: boolean = false;
  pendingDecution: boolean = false;

  userId: number;
  permissionArray: any;

  constructor(private odmoriService: OdmoriService, private toastr: ToastrService, private globals: Globals, private permissionsService: PermissionsService,private formBuilder: FormBuilder, private downloadService: FileDownloadService, public constants: ConstantsService) { }

  ngOnInit() {
    this.users = this.globals.getAllUsers();

    this.userId = +this.constants.creator_id;

    this.form = this.formBuilder.group({
      assigned: this.assigned,
    });

    this.generateYears(1900, new Date().getFullYear());

    this.yearControl.valueChanges.subscribe(selectedValues => {
      this.selectedYears = selectedValues;
    });

    this.permissionArray = this.globals.getPermittedUsers();
  };

  generateYears(startYear: number, endYear: number) {
    for (let year = endYear; year >= startYear; year--) {
      this.years.push(year);
    };
  };

  saveHolidaysDaysAndHours() {
    this.pendingSave = true;

    let usersNew = this.users.map(user => {
      return {
        id: user.id,
        days: user.days,
        hours: user.hours
      };
    });

    this.odmoriService.saveHolidaysDaysAndHours(usersNew, this.selectedYear).subscribe(response => {
      this.pendingSave = false;

      if (response.type == 'success') {
        this.toastr.success('Uspješno sačuvani podaci.');

        return;
      };

      this.toastr.error('Došlo je do greške prilikom čuvanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };


  getHolidaysDaysAndHours() {
    this.showEmployeeAbsenceData = false;
    this.pending = true;

    if(typeof this.selectedYear === 'undefined') {
      this.toastr.info('Molimo vas izaberite godinu.');
      this.pending = false;

      return;
    };

    this.odmoriService.getHolidaysDaysAndHours(this.selectedYear).subscribe(response => {
      if (response.type == 'success') {

        this.users.forEach((user, index) => {
          response.data.forEach(data => {
            if (user.id == data.user_id) {
              this.users[index].days = data.days;
              this.users[index].hours = data.hours;
            }
          });
        });

        this.showEmployeeAbsenceData = true;
        this.pending = false;

        return;
      };

      this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  getAbsences(excel = false) {
    this.previewEmployees = false;

    this.allAbsences = false;

    if(this.selectedYears.length === 0) {
      this.toastr.info('Molimo vas izaberite godinu.');
      this.pending = false;

      return;
    };

    if(excel) {
      this.pendingExport = true;
    } else {
      this.pending = true;
    };

    this.odmoriService.recalculateRemainingHolidayDaysAndHoursPerYear(this.selectedYears, excel).subscribe(response => {
      if (response.type == 'success') {

        if(excel) {
          this.downloadService.urlToBase64(response);

          this.pendingExport = false;

          return;
        };

        this.employeesAbsenceData = response.data;

        this.employeesAbsenceData.forEach((data, dataIndex) => {
          this.users.forEach((user, index) => {
            if (user.id == data.user_id) {
              this.employeesAbsenceData[dataIndex].first_name = user.first_name;
              this.employeesAbsenceData[dataIndex].last_name = user.last_name;
            }
          });
        });

        this.toastr.info(response.message);

        this.pending = false;
        this.previewEmployees = true;

        return;
      };

      this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  getAllAbsenceData(excel = false) {
    this.allAbsences = true;

    if(excel) {
      this.pendingExport = true;
    };

    this.odmoriService.getAllAbsenceData(excel).subscribe(response => {
      this.isLoading = false;

      if (response.type == 'success') {

        if(excel) {
          this.downloadService.urlToBase64(response);

          this.pendingExport = false;
          this.allAbsences = false;

          return;
        };

        this.employeesAbsenceData = response.data;

        this.employeesAbsenceData.forEach((data, dataIndex) => {
          this.users.forEach((user, index) => {
            if (user.id == data.user_id) {
              this.employeesAbsenceData[dataIndex].first_name = user.first_name;
              this.employeesAbsenceData[dataIndex].last_name = user.last_name;
            }
          });
        });

        this.toastr.info(response.message);

        this.pending = false;
        this.previewEmployees = true;

        return;
      };

      this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  loadPermissionsData() {
    this.showPermittedUsers = false;

    this.permissionsService.getPermittedUsersForHolidaysModule().subscribe(response => {
      if (response.type == 'success') {

        if(response.data.length == 0) {
          this.toastr.info('Nemate dodatih osoba koje će dijeliti Vaše permisije.');

          return;
        };

        this.allowedUserPermission = response.data;

        this.showPermittedUsers = true;

        return;
      };

      this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  getAssignedIds(data: any) {
    this.form.patchValue({'assigned': data});
  };

  saveNewHolidayPermissions() {
    this.pendingSaveUser = true;

    let allowedUsers = this.users.filter(user => this.assigned.value.includes(user.id)).map(user => ({
      user_id: user.id,
      ime_prezime: user.first_name + " " + user.last_name,
    }));

    if (allowedUsers.length === 0) {
      this.toastr.info('Molimo Vas izaberite osobu koja će dijeliti Vaše permisije.');

      this.pendingSaveUser = false;

      return;
    };

    this.permissionsService.savePermittedUsersForHolidaysModule(allowedUsers).subscribe(response => {
      if (response.type == 'success') {

        this.toastr.success('Uspješno sačuvani podaci!');

        this.loadPermissionsData();

        this.pendingSaveUser = false;

        this.form.patchValue({'assigned': null});

        return;
      };

      this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  exportXLS() {
    this.pendingExport = false;

    if(this.allAbsences) {
      this.getAllAbsenceData(true);
    } else {
      this.getAbsences(true);
    };
  };

  deductUserPermission(permission) {
    this.pendingDecution = true;

    this.toastr.info("Uklanjanje permisije je u toku.");

    this.permissionsService.deductUserPermission(permission).subscribe(response => {
      if (response.type == 'success') {

        this.toastr.success(response.message);

        this.loadPermissionsData();

        this.pendingDecution = false;

        return;
      };

      this.toastr.error('Došlo je do greške prilikom brisanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

}
